[
  {
    "label": "containerNo",
    "displayLabel": "Container",
    "editable": false,
    "isPinned": true
  },
  {
    "label": "hazardous",
    "displayLabel": "Hazardous",
    "editable": true,
    "fieldInfo": {
      "dataType": "boolean"
    }
  },
  {
    "label": "imdgClass",
    "displayLabel": "IMDG Class",
    "placeholder": "Enter IMDG Class",
    "editable": true,
    "fieldInfo": {
      "dataType": "text"
    }
  },
  {
    "label": "unNo",
    "displayLabel": "UN No",
    "placeholder": "Enter UN No",
    "editable": true,
    "fieldInfo": {
      "dataType": "text"
    }
  },
  {
    "label": "deliveryMode",
    "displayLabel": "Delivery Mode",
    "placeholder": "Enter Delivery Mode",
    "editable": true,
    "fieldInfo": {
      "dataType": "select",
      "options": [
        {
          "value": "FACTORY",
          "label": "Loaded Delivery"
        },
        {
          "value": "DOCK",
          "label": "Destuff Delivery"
        }
      ]
    }
  },
  {
    "label": "toLocationId",
    "displayLabel": "Empty Drop Yard",
    "placeholder": "Enter Empty Drop Yard",
    "id": "toLocationId",
    "hasLookup": true,
    "fieldInfo": {
      "dataType": "picklist",
      "lookupDetails": {
        "apiUrl": "v1/locations/list",
        "filterByKeys": ["NAME_CONTAINS"],
        "limit": 10,
        "orderBy": { "name": "asc" },
        "filterByKey": "name",
        "bindLabel": "name",
        "bindValue": "id",
        "responseBindValue": "toLocationId",
        "responseBindLabel": "toLocationName",
        "additionalFilters": [
          {
            "name": "IS_ACTIVE",
            "alias": "active",
            "operator": "EQ",
            "value": ["true"]
          }
        ],
        "displayColumns": [
          { "key": "name", "header": "Name" },
          { "key": "panNumber", "header": "PAN Number" }
        ]
      }
    },
    "editable": true
  },
  {
    "label": "containerSize",
    "displayLabel": "Size",
    "editable": false
  },
  {
    "label": "containerType",
    "displayLabel": "Type",
    "editable": false
  },
  {
    "label": "importType",
    "displayLabel": "Import Type",
    "editable": false
  },
  {
    "label": "gateInDate",
    "displayLabel": "Arrival Date",
    "editable": false,
    "fieldInfo": {
      "dataType": "dateTime"
    }
  },
  {
    "label": "totalPackages",
    "displayLabel": "NOP",
    "editable": false
  },
  {
    "label": "cargoWeight",
    "displayLabel": "Cargo Weight",
    "editable": false
  },
  {
    "label": "tareWeight",
    "displayLabel": "Tare Weight",
    "editable": false
  },
  {
    "label": "grossWeight",
    "displayLabel": "Gross Weight",
    "editable": false
  },
  {
    "label": "scanType",
    "displayLabel": "Scan Type",
    "editable": false
  },
  {
    "label": "scanStatus",
    "displayLabel": "Scan Status",
    "editable": false
  }
]
